<template>
  <div :class="classList">
    <el-tag
        :class="`status-${status}`"
        class="button2"
        size="small"
    >
      <div class="capitalize-first-letter">{{ status }}</div>
    </el-tag>
  </div>
</template>
<script>

export default {
  name: "StateTag",
  props: {
    status: {type: String},
    classList: {type: String}
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

>>> .button2 {
  width: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-ACTIVE {
  color: #315D1C;
  border: 0.5px solid #AEDB97;
  background: #F0F9EB;
}

.status-INACTIVE {
  color: #292c32;
  border-color: var(--aluminum-900);
  background: #292c32;
}

.status-MITIGATED {
  border: 0.5px solid #9AC9FA;
  color: #003A80;
  background: #ECF5FF;
}

.status-REOPENED {
  border: 0.5px solid #EDCB98;
  color: #654B23;
  background: #FDF6EC;
}

</style>



// WEBPACK FOOTER //
// src/components/button/StateTag.vue